import {useContext} from 'react';
import {GuestCreationContext} from './GuestCreationContext';

export const useGuestCreationContext = () => {
  const context = useContext(GuestCreationContext);
  if (context === undefined) {
    throw new Error(
      'useGuestCreationContext must be used within a GuestCreationProvider',
    );
  }
  return context;
};
